import PropTypes from "prop-types";
import styled from "styled-components";

var Bubble = styled("div").withConfig({
  displayName: "Bubble",
  componentId: "sc-1juk677-0"
})(["color:", ";background:", ";border-radius:", ";border:1px solid ", ";padding:", ";font-size:", ";font-family:", ";"], function (props) {
  return props.color ? props.color : "inherit";
}, function (props) {
  return props.background ? props.background : "inherit";
}, function (props) {
  return props.radius ? props.radius + "px" : 0;
}, function (props) {
  return props.border;
}, function (props) {
  return props.padding ? props.padding + "px" : 0;
}, function (props) {
  return props.fontSize;
}, function (props) {
  return props.fontFamily;
});

Bubble.propTypes = {
  color: PropTypes.string,
  background: PropTypes.string,
  padding: PropTypes.number,
  radius: PropTypes.number,
  fontSize: PropTypes.string,
  fontFamily: PropTypes.string
};

export default Bubble;